<script>
    import R, {LOADER} from "../lib/requests";
    import app from '../stores/app';
    import user from '../stores/user';
    import {formatDate, setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";
    import Modal from "../components/modal/Modal.svelte";
    import NumberSpinner from "../components/controls/NumberSpinner.svelte";
    import {RESERVATION_STATUS, RESERVATION_STATUSES} from "../lib/constants";
    import Checkbox from "../components/controls/Checkbox.svelte";

    export let reservationId = 0;
    export let reservationDate = null;
    export let closeCallback;

    let reservation = null;
    let title = "Reservation";
    let sendEmail = false;
    let emails = [];
    let emailMessage = null;

    const initialize = () => {
        if (reservationId == 0) {
            reservation = {
                id: 0,
                agent_id: $user.agent_id || 0,
                name: '',
                phone: '',
                date_at: reservationDate,
                persons: 2,
                notes: '',
                status: 1,
            }
            // setFocusTo('name');
            title = "New reservation";
        } else {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            reservation = result;
            reservation.agent_id = reservation.agent_id == 0 ? ~~reservation.agent_id : reservation.agent_id;
            reservation.status = ~~reservation.status;

            if (reservation.agent) {
                if (reservation.agent.email) {
                    emails.push({checked: 1, email: reservation.agent.email});
                }
                reservation.agent.users.map(item => {
                    if (item.email) {
                        if (emails.filter(x => x.email == item.email).length == 0) {
                            emails.push({checked: 1, email: item.email});
                        }
                    }
                });
                console.log(emails);
            }

            setFocusTo('name');
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.details, reservationId, onSuccess, onFailure, LOADER.POPUP);
    }

    const save = () => {

        const onSuccess = result => {
            reservation = result;
            Notifier.showMessage("Reservation saved");
            if (sendEmail) {
                sendEmailToAgent();
                return;
            }
            close(reservation);
        }

        const onFailure = err => {
            if (err.code === 'not_allowed') {
                if (err.params?.field === 'persons') {
                    Alert.warning("Save reservation", `The number of persons exceeds the daily limit!`);
                    return;
                }
                if (err.params?.field === 'date_at') {
                    Alert.warning("Save reservation", `Sales have stopped on this date!`);
                    return;
                }
            }

            if (err.code === 'field_required' || err.code === 'field_invalid') {
                Notifier.showError("Some fields do not contain a valid value!");
                if (err.params && err.params.field) {
                    setFocusTo(`res_${err.params.field}`);
                }
            }
        };

        if (reservation.status != RESERVATION_STATUS.CANCELED) {
            sendEmail = false;
            emailMessage = null;
        } else {
            if (emails.filter(x => x.checked == 1)?.length == 0) {
                Alert.warning("Send email", "You have not selected email addresses to send the message to.");
                return;
            }
        }

        let action = reservationId == 0 ? 'create' : 'edit';
        R.handle(R.reservation[action], reservation, onSuccess, onFailure, LOADER.POPUP);
    }

    const sendEmailToAgent = () => {
        const onSuccess = result => {
            sendEmail = false;
            emailMessage = null;
            Notifier.showMessage("Email sent successfully");
            close(reservation);
        }

        const onFailure = err => {
            let message = `Could not send email to recipients!`;

            if (err.params && err.params.message) {
                message = err.params.message;
            }

            Alert.warning("Send mail", message);
        };

        let recipients = emails.map(item => {
            if (item.checked == 1) {
                return item.email;
            }
        })

        R.handle(R.reservation.sendMail, {
            id: reservation.id,
            message: emailMessage,
            recipients
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if reservation}
    <Modal {title} on:close="{ close }">
        <div slot="body">
            {#if user.isAdmin()}
                <div class="form-group">
                    <label>Agency</label>
                    <select class="form-select" bind:value="{reservation.agent_id}">
                        <option value={0}>no agency</option>
                        {#each $app.agents as agent}
                            <option value="{agent.id}">{agent.name}</option>
                        {/each}
                    </select>
                </div>
            {/if}
            <div class="form-group">
                <label>Date</label>
                <input type="date" class="form-control" id="res_date_at" bind:value="{ reservation.date_at }"/>
            </div>
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="res_name" bind:value="{ reservation.name }"/>
            </div>
            <div class="row">
                <div class="col-md-6 col-7 form-group">
                    <label>Phone</label>
                    <input type="tel" class="form-control" bind:value="{ reservation.phone }"
                           placeholder="phone with country code"/>
                </div>
                <div class="col-md-6 col-5 form-group">
                    <label>Persons</label>
                    <NumberSpinner bind:value={reservation.persons} minValue="1" maxValue={$app.settings.max_cruise_persons}/>
                </div>
            </div>
            <div class="form-group">
                <label>Notes</label>
                <textarea class="form-control" bind:value={reservation.notes}></textarea>
            </div>

            {#if reservationId > 0}
                <hr>
                {#if user.isAdmin()}
                    <div class="form-group">
                        <label>Status</label>
                        <select class="form-select" bind:value="{reservation.status}">
                            {#each RESERVATION_STATUSES as status, index}
                                {#if index > 0}
                                    <option value="{index}">{RESERVATION_STATUSES[index]}</option>
                                {/if}
                            {/each}
                        </select>
                    </div>
                {/if}
                {#if reservation.status == RESERVATION_STATUS.CANCELED && reservation.agent_id > 0}
                    <div class="form-group">
                        <Checkbox label="Send email to agent" bind:checked={sendEmail}/>
                    </div>
                {/if}
                {#if sendEmail}
                    <div class="legend">Cancelation message</div>
                    <div class="form-group">
                        <textarea class="form-control" bind:value={emailMessage}></textarea>
                    </div>
                    <div class="form-group">
                        <div class="legend">Send to</div>
                        {#if emails.length > 0}
                            {#each emails as item}
                                <div class="py-1 my-1">
                                    <Checkbox label={item.email} bind:checked={item.checked}/>
                                </div>
                            {/each}
                        {:else}
                            <div class="text-danger">There are no emails to send the message</div>
                        {/if}
                    </div>
                {/if}

                <div class="small">
                    <span class="text-gray">Created at</span> {formatDate(reservation.created_at, 'd-m-y')}
                    <span class="text-gray">by</span> {reservation?.user?.name}
                </div>
            {/if}

            <hr>
            <div class="text-end">
                <button class="btn btn-link me-2" on:click="{ close }">Close</button>
                <button class="btn btn-primary px-4" on:click="{ save }">SAVE</button>
            </div>
        </div>
    </Modal>
{/if}